namespace RioERP.Web.Enums {
    export enum ShippingType {
        ByHand = 1,
        ByCourier = 2
    }
    Serenity.Decorators.registerEnumType(ShippingType, 'RioERP.Web.Enums.ShippingType');
}
